import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Tooltip,
  TableSortLabel,
  Typography,
  Button,
} from '@mui/material';
import { EditOutlined, DeleteOutlined, VisibilityOutlined, Description } from '@mui/icons-material';
import useSortTable from '../../../hooks/useSortTable';

const TemplateTable = ({ templates, onEdit, onDelete, page, onPageChange, pagination, canEdit, canDelete }) => {
  const { sorted, sortBy, sortDir, handleSort } = useSortTable(templates);

  if (!templates || templates.length === 0) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Description sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
        <p>No hay plantillas registradas</p>
      </Paper>
    );
  }

  const truncateText = (text, maxLength = 100) => {
    if (!text) return '-';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  const SortCell = ({ label, field, sx: extraSx }) => (
    <TableCell onClick={() => handleSort(field)} sx={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap', ...extraSx }}>
      <TableSortLabel active={sortBy === field} direction={sortBy === field ? sortDir : 'asc'}>
        {label}
      </TableSortLabel>
    </TableCell>
  );

  const totalPages = pagination ? Math.ceil((pagination.total || 0) / (pagination.limit || 10)) : 1;
  const from = pagination ? ((page - 1) * (pagination.limit || 10)) + 1 : 1;

  return (
    <Box>
      <Paper sx={{ overflow: 'hidden' }}>
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <SortCell label="Titulo" field="title" />
                <SortCell label="Descripcion" field="description" sx={{ display: { xs: 'none', sm: 'table-cell' } }} />
                <SortCell label="Empresa" field="company.name" sx={{ display: { xs: 'none', md: 'table-cell' } }} />
                <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sorted.map((template) => (
                <TableRow key={template.id} hover>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontFamily: '"Barlow Condensed", system-ui, sans-serif', fontWeight: 600 }}>
                      {template.title}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                    <Typography variant="body2">{truncateText(template.description, 80)}</Typography>
                  </TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                    <Typography variant="body2">{template.company?.name || '-'}</Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                    <Box sx={{ display: 'inline-flex', gap: 0.25 }}>
                      {canEdit && (
                        <Tooltip title="Vista previa">
                          <IconButton size="small" onClick={() => onEdit(template)} sx={{ color: '#5d5d60', width: 36, height: 36 }}>
                            <VisibilityOutlined sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                      {canEdit && (
                        <Tooltip title="Editar">
                          <IconButton size="small" onClick={() => onEdit(template)} sx={{ color: '#5d5d60', width: 36, height: 36 }}>
                            <EditOutlined sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                      {canDelete && (
                        <Tooltip title="Eliminar">
                          <IconButton size="small" onClick={() => onDelete(template.id)} sx={{ color: '#5d5d60', width: 36, height: 36 }}>
                            <DeleteOutlined sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {pagination && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, flexWrap: 'wrap', gap: 1 }}>
          <Typography sx={{ fontSize: '0.8125rem', color: 'rgba(29,31,32,0.55)' }}>
            Mostrando {from} de {pagination.total || 0} plantillas
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="outlined" size="small" disabled={page <= 1} onClick={() => onPageChange(page - 1)} sx={{ fontWeight: 600, minWidth: 90 }}>
              Anterior
            </Button>
            <Button variant="outlined" size="small" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} sx={{ fontWeight: 600, minWidth: 90 }}>
              Siguiente
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default TemplateTable;
